module.exports = __webpack_public_path__ + "static/13-5ed6919269e52da52d408da3c6e6acc9.jpg";